import { render, staticRenderFns } from "./AccessGrid.vue?vue&type=template&id=35ff1d8e"
import script from "./AccessGrid.vue?vue&type=script&lang=js"
export * from "./AccessGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports